// Main Icons
import SvgAccessibility from '@img/icons/accessibility.svg';
import SvgAccmanClientServices from '@img/icons/accman-client-services.svg';
import SvgAdstore from '@img/icons/adstore.svg';
import SvgAgencyManagement from '@img/icons/agency-management.svg';
import SvgAgencyPortal from '@img/icons/agency-portal.svg';
import SvgAlert from '@img/icons/alert.svg';
import SvgAngryFace from '@img/icons/angry-face.svg';
import SvgAnnounce from '@img/icons/announce.svg';
import SvgApi from '@img/icons/api.svg';
import SvgApplications from '@img/icons/applications.svg';
import SvgApprovalWorkflow from '@img/icons/approval-workflow.svg';
import SvgArrowThin from '@img/icons/arrow-thin.svg';
import SvgArrow from '@img/icons/arrow.svg';
import SvgAssessmentFormsChecklistsStructuredReviews from '@img/icons/assessment-forms-checklists-structured-reviews.svg';
import SvgAts from '@img/icons/ats.svg';
import SvgAutomation from '@img/icons/automation.svg';
import SvgAwardsSkills from '@img/icons/awards-skills.svg';
import SvgBarrier from '@img/icons/barrier.svg';
import SvgBenchmarkingKpis from '@img/icons/benchmarking-kpis.svg';
import SvgBook from '@img/icons/book.svg';
import SvgBrain from '@img/icons/brain.svg';
import SvgBrandFlower from '@img/icons/brand-flower.svg';
import SvgBrochures from '@img/icons/brochures.svg';
import SvgBulb from '@img/icons/bulb.svg';
import SvgBullet from '@img/icons/bullet.svg';
import SvgBulletFill from '@img/icons/bullet-fill.svg';
import SvgBySector from '@img/icons/by-sector.svg';
import SvgByUseCase from '@img/icons/by-use-case.svg';
import SvgCandidateAssessment from '@img/icons/candidate-assessment.svg';
import SvgCandidateAttractionProactiveRecruitment from '@img/icons/candidate-attraction-proactive-recruitment.svg';
import SvgCandidateEngagementAgencyFeedbackChat from '@img/icons/candidate-engagement-agency-feedback-chat.svg';
import SvgCandidateExperience from '@img/icons/candidate-experience.svg';
import SvgCandidatePortal from '@img/icons/candidate-portal.svg';
import SvgCandidateSelfService from '@img/icons/candidate-self-service.svg';
import SvgCandidates from '@img/icons/candidates.svg';
import SvgCareersWebsiteDesign from '@img/icons/careers-website-design.svg';
import SvgCareersWebsiteInterface from '@img/icons/careers-website-interface.svg';
import SvgCareers from '@img/icons/careers.svg';
import SvgCaseStudy from '@img/icons/case-study.svg';
import SvgChainBreak from '@img/icons/chain-break.svg';
import SvgCharitiesNfpWellnessHealthSocialCare from '@img/icons/charities-nfp-wellness-health-social-care.svg';
import SvgChevronRight from '@img/icons/chevron-right.svg';
import SvgChevron from '@img/icons/chevron.svg';
import SvgCircleClose from '@img/icons/circle-close.svg';
import SvgClipboardTick from '@img/icons/clipboard-tick.svg';
import SvgClockTurn from '@img/icons/clock-turn.svg';
import SvgClock from '@img/icons/clock.svg';
import SvgCollaboration from '@img/icons/collaboration.svg';
import SvgCommunicationFeedback from '@img/icons/communication-feedback.svg';
import SvgCompanyBrandLogoeye from '@img/icons/company-brand-logoeye.svg';
import SvgCompliance from '@img/icons/compliance.svg';
import SvgConfigurability from '@img/icons/configurability.svg';
import SvgConstructionInfrastructure from '@img/icons/construction-infrastructure.svg';
import SvgContractsAndEsignatures from '@img/icons/contracts-and-esignatures.svg';
import SvgCrossClose from '@img/icons/cross-close.svg';
import SvgCustomerSuccess from '@img/icons/customer-success.svg';
import SvgCustomer from '@img/icons/customer.svg';
import SvgCustomisableOptions from '@img/icons/customisable-options.svg';
import SvgDashboardsAndAnalytics from '@img/icons/dashboards-and-analytics.svg';
import SvgDataAccess from '@img/icons/data-access.svg';
import SvgDatasheets from '@img/icons/datasheets.svg';
import SvgDeveloperTools from '@img/icons/developer-tools.svg';
import SvgDeveloper from '@img/icons/developer.svg';
import SvgDownload from '@img/icons/download.svg';
import SvgEbooksAndReports from '@img/icons/ebooks-and-reports.svg';
import SvgEdi from '@img/icons/edi.svg';
import SvgEdit from '@img/icons/edit.svg';
import SvgEducation from '@img/icons/education.svg';
import SvgEfficiency from '@img/icons/efficiency.svg';
import SvgEmail from '@img/icons/email.svg';
import SvgEmployeePortal from '@img/icons/employee-portal.svg';
import SvgEmployeeReferrals from '@img/icons/employee-referrals.svg';
import SvgEmployees from '@img/icons/employees.svg';
import SvgEmployerBrand from '@img/icons/employer-brand.svg';
import SvgEngineeringAndManufacturing from '@img/icons/engineering-and-manufacturing.svg';
import SvgFacilitiesManagement from '@img/icons/facilities-management.svg';
import SvgFilter from '@img/icons/filter.svg';
import SvgFinancialServices from '@img/icons/financial-services.svg';
import SvgFloorplan from '@img/icons/floorplan.svg';
import SvgFoodAndDrink from '@img/icons/food-and-drink.svg';
import SvgGdpr from '@img/icons/gdpr.svg';
import SvgGlobe from '@img/icons/globe.svg';
import SvgGrowth from '@img/icons/growth.svg';
import SvgHiringManagerPortal from '@img/icons/hiring-manager-portal.svg';
import SvgHiringManagers from '@img/icons/hiring-managers.svg';
import SvgHospitality from '@img/icons/hospitality.svg';
import SvgHowWeWork from '@img/icons/how-we-work.svg';
import SvgHr from '@img/icons/hr.svg';
import SvgImplementation from '@img/icons/implementation.svg';
import SvgIndeedIntegration from '@img/icons/indeed-integration.svg';
import SvgInnovativeTechnology from '@img/icons/innovative-technology.svg';
import SvgIntegrations from '@img/icons/integrations.svg';
import SvgInterviewSchedulingCalendarsTimeAndAttendance from '@img/icons/interview-scheduling-calendars-time-and-attendance.svg';
import SvgInterviews from '@img/icons/interviews.svg';
import SvgIt from '@img/icons/it.svg';
import SvgJobAdvertisingNews from '@img/icons/job-advertising-news.svg';
import SvgJobLibrary from '@img/icons/job-library.svg';
import SvgJobOffersAgencyPartnersAlliancePartnersChannelPartners from '@img/icons/job-offers-agency-partners-alliance-partners-channel-partners.svg';
import SvgJobRequisitionsBackgroundChecks from '@img/icons/job-requisitions-background-checks.svg';
import SvgJobSearch from '@img/icons/job-search.svg';
import SvgKnowledgeBase from '@img/icons/knowledge-base.svg';
import SvgLegal from '@img/icons/legal.svg';
import SvgLightning from '@img/icons/lightning.svg';
import SvgLocation from '@img/icons/location.svg';
import SvgLock from '@img/icons/lock.svg';
import SvgMarketplace from '@img/icons/marketplace.svg';
import SvgMeasureSatisfaction from '@img/icons/measure-satisfaction.svg';
import SvgMeasure from '@img/icons/measure.svg';
import SvgMediaAndCreative from '@img/icons/media-and-creative.svg';
import SvgMenu from '@img/icons/menu.svg';
import SvgMessageConfirm from '@img/icons/message-confirm.svg';
import SvgMetrics from '@img/icons/metrics.svg';
import SvgMigration from '@img/icons/migration.svg';
import SvgMinus from '@img/icons/minus.svg';
import SvgMobileFriendly from '@img/icons/mobile-friendly.svg';
import SvgMoney from '@img/icons/money.svg';
import SvgMultiposting from '@img/icons/multiposting.svg';
import SvgNoData from '@img/icons/no-data.svg';
import SvgNonCompliance from '@img/icons/non-compliance.svg';
import SvgNotifications from '@img/icons/notifications.svg';
import SvgOnboarding from '@img/icons/onboarding.svg';
import SvgOurServices from '@img/icons/our-services.svg';
import SvgPartners from '@img/icons/partners.svg';
import SvgPencil from '@img/icons/pencil.svg';
import SvgPhone from '@img/icons/phone.svg';
import SvgPipelines from '@img/icons/pipelines.svg';
import SvgPlay from '@img/icons/play.svg';
import SvgProfessionalServicesAndConsultancies from '@img/icons/professional-services-and-consultancies.svg';
import SvgProfile from '@img/icons/profile.svg';
import SvgPublicSector from '@img/icons/public-sector.svg';
import SvgQuoteTestimonials from '@img/icons/quote-testimonials.svg';
import SvgRecruitmentMarketingTargettingOurimpact from '@img/icons/recruitment-marketing-targetting-ourimpact.svg';
import SvgRecruitmentWorkflow from '@img/icons/recruitment-workflow.svg';
import SvgReferenceCollection from '@img/icons/reference-collection.svg';
import SvgReferralProgrammeManagement from '@img/icons/referral-programme-management.svg';
import SvgRegistration from '@img/icons/registration.svg';
import SvgRequestToRecruit from '@img/icons/request-to-recruit.svg';
import SvgResearchAndInstitutes from '@img/icons/research-and-institutes.svg';
import SvgResellCosell from '@img/icons/resell-cosell.svg';
import SvgResources from '@img/icons/resources.svg';
import SvgRetail from '@img/icons/retail.svg';
import SvgRewardStore from '@img/icons/reward-store.svg';
import SvgRpo from '@img/icons/rpo.svg';
import SvgRtwChecks from '@img/icons/rtw-checks.svg';
import SvgSadFace from '@img/icons/sad-face.svg';
import SvgScienceAndPharma from '@img/icons/science-and-pharma.svg';
import SvgSearchTalentPool from '@img/icons/search-talent-pool.svg';
import SvgSearch from '@img/icons/search.svg';
import SvgSecurity from '@img/icons/security.svg';
import SvgSent from '@img/icons/sent.svg';
import SvgSettingsVisualisationsRecruitmentCrm from '@img/icons/settings-visualisations-recruitment-crm.svg';
import SvgSingleSignOn from '@img/icons/single-sign-on.svg';
import SvgSolveYourChallenges from '@img/icons/solve-your-challenges.svg';
import SvgStats from '@img/icons/stats.svg';
import SvgSubmitAServiceRequest from '@img/icons/submit-a-service-request.svg';
import SvgSubmitAgencyCandidates from '@img/icons/submit-agency-candidates.svg';
import SvgTalentMapping from '@img/icons/talent-mapping.svg';
import SvgTalentNurturing from '@img/icons/talent-nurturing.svg';
import SvgTalentPool from '@img/icons/talent-pool.svg';
import SvgTeamsManagementTeams from '@img/icons/teams-management-teams.svg';
import SvgTechnologyTechPartners from '@img/icons/technology-tech-partners.svg';
import SvgThumbsDown from '@img/icons/thumbs-down.svg';
import SvgThumbsUp from '@img/icons/thumbs-up.svg';
import SvgTickInCircle from '@img/icons/tick-in-circle.svg';
import SvgTick from '@img/icons/tick.svg';
import SvgTimeToHireImprovement from '@img/icons/time-to-hire-improvement.svg';
import SvgToolbox from '@img/icons/toolbox.svg';
import SvgTracking from '@img/icons/tracking.svg';
import SvgTraining from '@img/icons/training.svg';
import SvgTransportAndLogistics from '@img/icons/transport-and-logistics.svg';
import SvgUpload from '@img/icons/upload.svg';
import SvgUserFriendlyInterface from '@img/icons/user-friendly-interface.svg';
import SvgUserProvisioning from '@img/icons/user-provisioning.svg';
import SvgUser from '@img/icons/user.svg';
import SvgUsersAndRoles from '@img/icons/users-and-roles.svg';
import SvgUtilitiesAndWasteManagement from '@img/icons/utilities-and-waste-management.svg';
import SvgVerified from '@img/icons/verified.svg';
import SvgVideoInterviewing from '@img/icons/video-interviewing.svg';
import SvgVideo from '@img/icons/video.svg';
import SvgViewport from '@img/icons/viewport.svg';
import SvgWarning from '@img/icons/warning.svg';
import SvgWhyEploy from '@img/icons/why-eploy.svg';
import SvgWindows from '@img/icons/windows.svg';
import SvgWorkflow from '@img/icons/workflow.svg';
import SvgWrench from '@img/icons/wrench.svg';
// Copy link icon 
import SvgCopyLink from '@img/icons/social/copylink.svg';
// Social Media Icons
import SvgFacebook from '@img/icons/social/facebook.svg';
import SvgFounderResources from '@img/icons/social/founder-resources.svg';
import SvgG2 from '@img/icons/social/g2.svg';
import SvgInstagram from '@img/icons/social/instagram.svg';
import SvgLinkedIn from '@img/icons/social/linked-in.svg';
import SvgPinterest from '@img/icons/social/pinterest.svg';
import SvgX from '@img/icons/social/x.svg';
import SvgYouTube from '@img/icons/social/youtube.svg';
import React from 'react';
import { PuffLoader } from 'react-spinners';
export var Icon;
(function (Icon) {
    Icon["Accessibility"] = "accessibility";
    Icon["AccmanClientServices"] = "accman-client-services";
    Icon["Adstore"] = "adstore";
    Icon["AgencyManagement"] = "agency-management";
    Icon["AgencyPortal"] = "agency-portal";
    Icon["Alert"] = "alert";
    Icon["AngryFace"] = "angry-face";
    Icon["Announce"] = "announce";
    Icon["Api"] = "api";
    Icon["Applications"] = "applications";
    Icon["ApprovalWorkflow"] = "approval-workflow";
    Icon["ArrowThin"] = "arrow-thin";
    Icon["Arrow"] = "arrow";
    Icon["AssessmentFormsChecklistsStructuredReviews"] = "assessment-forms-checklists-structured-reviews";
    Icon["Ats"] = "ats";
    Icon["Automation"] = "automation";
    Icon["AwardsSkills"] = "awards-skills";
    Icon["Barrier"] = "barrier";
    Icon["BenchmarkingKpis"] = "benchmarking-kpis";
    Icon["Book"] = "book";
    Icon["Brain"] = "brain";
    Icon["BrandFlower"] = "brand-flower";
    Icon["Brochures"] = "brochures";
    Icon["Bulb"] = "bulb";
    Icon["Bullet"] = "bullet";
    Icon["BulletFill"] = "bullet-fill";
    Icon["BySector"] = "by-sector";
    Icon["ByUseCase"] = "by-use-case";
    Icon["CandidateAssessment"] = "candidate-assessment";
    Icon["CandidateAttractionProactiveRecruitment"] = "candidate-attraction-proactive-recruitment";
    Icon["CandidateEngagementAgencyFeedbackChat"] = "candidate-engagement-agency-feedback-chat";
    Icon["CandidateExperience"] = "candidate-experience";
    Icon["CandidatePortal"] = "candidate-portal";
    Icon["CandidateSelfService"] = "candidate-self-service";
    Icon["Candidates"] = "candidates";
    Icon["CareersWebsiteDesign"] = "careers-website-design";
    Icon["CareersWebsiteInterface"] = "careers-website-interface";
    Icon["Careers"] = "careers";
    Icon["CaseStudy"] = "case-study";
    Icon["ChainBreak"] = "chain-break";
    Icon["CharitiesNfpWellnessHealthSocialCare"] = "charities-nfp-wellness-health-social-care";
    Icon["ChevronRight"] = "chevron-right";
    Icon["Chevron"] = "chevron";
    Icon["CircleClose"] = "circle-close";
    Icon["ClipboardTick"] = "clipboard-tick";
    Icon["ClockTurn"] = "clock-turn";
    Icon["Clock"] = "clock";
    Icon["Collaboration"] = "collaboration";
    Icon["CommunicationFeedback"] = "communication-feedback";
    Icon["CompanyBrandLogoeye"] = "company-brand-logoeye";
    Icon["Compliance"] = "compliance";
    Icon["Configurability"] = "configurability";
    Icon["ConstructionInfrastructure"] = "construction-infrastructure";
    Icon["ContractsAndEsignatures"] = "contracts-and-esignatures";
    Icon["CrossClose"] = "cross-close";
    Icon["CustomerSuccess"] = "customer-success";
    Icon["Customer"] = "customer";
    Icon["CustomisableOptions"] = "customisable-options";
    Icon["DashboardsAndAnalytics"] = "dashboards-and-analytics";
    Icon["DataAccess"] = "data-access";
    Icon["Datasheets"] = "datasheets";
    Icon["DeveloperTools"] = "developer-tools";
    Icon["Developer"] = "developer";
    Icon["Download"] = "download";
    Icon["EbooksAndReports"] = "ebooks-and-reports";
    Icon["Edi"] = "edi";
    Icon["Edit"] = "edit";
    Icon["Education"] = "education";
    Icon["Efficiency"] = "efficiency";
    Icon["Email"] = "email";
    Icon["EmployeePortal"] = "employee-portal";
    Icon["EmployeeReferrals"] = "employee-referrals";
    Icon["Employees"] = "employees";
    Icon["EmployerBrand"] = "employer-brand";
    Icon["EngineeringAndManufacturing"] = "engineering-and-manufacturing";
    Icon["FacilitiesManagement"] = "facilities-management";
    Icon["Filter"] = "filter";
    Icon["FinancialServices"] = "financial-services";
    Icon["Floorplan"] = "floorplan";
    Icon["FoodAndDrink"] = "food-and-drink";
    Icon["Gdpr"] = "gdpr";
    Icon["Globe"] = "globe";
    Icon["Growth"] = "growth";
    Icon["HiringManagerPortal"] = "hiring-manager-portal";
    Icon["HiringManagers"] = "hiring-managers";
    Icon["Hospitality"] = "hospitality";
    Icon["HowWeWork"] = "how-we-work";
    Icon["Hr"] = "hr";
    Icon["Implementation"] = "implementation";
    Icon["IndeedIntegration"] = "indeed-integration";
    Icon["InnovativeTechnology"] = "innovative-technology";
    Icon["Integrations"] = "integrations";
    Icon["InterviewSchedulingCalendarsTimeAndAttendance"] = "interview-scheduling-calendars-time-and-attendance";
    Icon["Interviews"] = "interviews";
    Icon["It"] = "it";
    Icon["JobAdvertisingNews"] = "job-advertising-news";
    Icon["JobLibrary"] = "job-library";
    Icon["JobOffersAgencyPartnersAlliancePartnersChannelPartners"] = "job-offers-agency-partners-alliance-partners-channel-partners";
    Icon["JobRequisitionsBackgroundChecks"] = "job-requisitions-background-checks";
    Icon["JobSearch"] = "job-search";
    Icon["KnowledgeBase"] = "knowledge-base";
    Icon["Legal"] = "legal";
    Icon["Lightning"] = "lightning";
    Icon["Location"] = "location";
    Icon["Lock"] = "lock";
    Icon["Marketplace"] = "marketplace";
    Icon["MeasureSatisfaction"] = "measure-satisfaction";
    Icon["Measure"] = "measure";
    Icon["MediaAndCreative"] = "media-and-creative";
    Icon["Menu"] = "menu";
    Icon["MessageConfirm"] = "message-confirm";
    Icon["Metrics"] = "metrics";
    Icon["Migration"] = "migration";
    Icon["Minus"] = "minus";
    Icon["MobileFriendly"] = "mobile-friendly";
    Icon["Money"] = "money";
    Icon["Multiposting"] = "multiposting";
    Icon["NoData"] = "no-data";
    Icon["NonCompliance"] = "non-compliance";
    Icon["Notifications"] = "notifications";
    Icon["Onboarding"] = "onboarding";
    Icon["OurServices"] = "our-services";
    Icon["Partners"] = "partners";
    Icon["Pencil"] = "pencil";
    Icon["Phone"] = "phone";
    Icon["Pipelines"] = "pipelines";
    Icon["Play"] = "play";
    Icon["ProfessionalServicesAndConsultancies"] = "professional-services-and-consultancies";
    Icon["Profile"] = "profile";
    Icon["PublicSector"] = "public-sector";
    Icon["QuoteTestimonials"] = "quote-testimonials";
    Icon["RecruitmentMarketingTargettingOurimpact"] = "recruitment-marketing-targetting-ourimpact";
    Icon["RecruitmentWorkflow"] = "recruitment-workflow";
    Icon["ReferenceCollection"] = "reference-collection";
    Icon["ReferralProgrammeManagement"] = "referral-programme-management";
    Icon["Registration"] = "registration";
    Icon["RequestToRecruit"] = "request-to-recruit";
    Icon["ResearchAndInstitutes"] = "research-and-institutes";
    Icon["ResellCosell"] = "resell-cosell";
    Icon["Resources"] = "resources";
    Icon["Retail"] = "retail";
    Icon["RewardStore"] = "reward-store";
    Icon["Rpo"] = "rpo";
    Icon["RtwChecks"] = "rtw-checks";
    Icon["SadFace"] = "sad-face";
    Icon["ScienceAndPharma"] = "science-and-pharma";
    Icon["SearchTalentPool"] = "search-talent-pool";
    Icon["Search"] = "search";
    Icon["Security"] = "security";
    Icon["Sent"] = "sent";
    Icon["SettingsVisualisationsRecruitmentCrm"] = "settings-visualisations-recruitment-crm";
    Icon["SingleSignOn"] = "single-sign-on";
    Icon["SolveYourChallenges"] = "solve-your-challenges";
    Icon["Stats"] = "stats";
    Icon["SubmitAServiceRequest"] = "submit-a-service-request";
    Icon["SubmitAgencyCandidates"] = "submit-agency-candidates";
    Icon["TalentMapping"] = "talent-mapping";
    Icon["TalentNurturing"] = "talent-nurturing";
    Icon["TalentPool"] = "talent-pool";
    Icon["TeamsManagementTeams"] = "teams-management-teams";
    Icon["TechnologyTechPartners"] = "technology-tech-partners";
    Icon["ThumbsDown"] = "thumbs-down";
    Icon["ThumbsUp"] = "thumbs-up";
    Icon["TickInCircle"] = "tick-in-circle";
    Icon["Tick"] = "tick";
    Icon["TimeToHireImprovement"] = "time-to-hire-improvement";
    Icon["Toolbox"] = "toolbox";
    Icon["Tracking"] = "tracking";
    Icon["Training"] = "training";
    Icon["TransportAndLogistics"] = "transport-and-logistics";
    Icon["Upload"] = "upload";
    Icon["UserFriendlyInterface"] = "user-friendly-interface";
    Icon["UserProvisioning"] = "user-provisioning";
    Icon["User"] = "user";
    Icon["UsersAndRoles"] = "users-and-roles";
    Icon["UtilitiesAndWasteManagement"] = "utilities-and-waste-management";
    Icon["Verified"] = "verified";
    Icon["VideoInterviewing"] = "video-interviewing";
    Icon["Video"] = "video";
    Icon["Viewport"] = "viewport";
    Icon["Warning"] = "warning";
    Icon["WhyEploy"] = "why-eploy";
    Icon["Windows"] = "windows";
    Icon["Workflow"] = "workflow";
    Icon["Wrench"] = "wrench";
    // Custom
    Icon["CopyLink"] = "copylink";
    Icon["None"] = "none";
    Icon["Loader"] = "loader";
    Icon["Facebok"] = "facebook";
    Icon["FounderResources"] = "founder-resources";
    Icon["G2"] = "g2";
    Icon["Instagram"] = "instagram";
    Icon["LinkedIn"] = "linkedin";
    Icon["Pinterest"] = "pinterest";
    Icon["X"] = "x";
    Icon["YouTube"] = "youtube";
})(Icon || (Icon = {}));
export function getSvgIcon(icon) {
    switch (icon) {
        case Icon.Accessibility: {
            return React.createElement(SvgAccessibility, null);
        }
        case Icon.AccmanClientServices: {
            return React.createElement(SvgAccmanClientServices, null);
        }
        case Icon.Adstore: {
            return React.createElement(SvgAdstore, null);
        }
        case Icon.AgencyManagement: {
            return React.createElement(SvgAgencyManagement, null);
        }
        case Icon.AgencyPortal: {
            return React.createElement(SvgAgencyPortal, null);
        }
        case Icon.Alert: {
            return React.createElement(SvgAlert, null);
        }
        case Icon.AngryFace: {
            return React.createElement(SvgAngryFace, null);
        }
        case Icon.Announce: {
            return React.createElement(SvgAnnounce, null);
        }
        case Icon.Api: {
            return React.createElement(SvgApi, null);
        }
        case Icon.Applications: {
            return React.createElement(SvgApplications, null);
        }
        case Icon.ApprovalWorkflow: {
            return React.createElement(SvgApprovalWorkflow, null);
        }
        case Icon.ArrowThin: {
            return React.createElement(SvgArrowThin, null);
        }
        case Icon.Arrow: {
            return React.createElement(SvgArrow, null);
        }
        case Icon.AssessmentFormsChecklistsStructuredReviews: {
            return React.createElement(SvgAssessmentFormsChecklistsStructuredReviews, null);
        }
        case Icon.Ats: {
            return React.createElement(SvgAts, null);
        }
        case Icon.Automation: {
            return React.createElement(SvgAutomation, null);
        }
        case Icon.AwardsSkills: {
            return React.createElement(SvgAwardsSkills, null);
        }
        case Icon.Barrier: {
            return React.createElement(SvgBarrier, null);
        }
        case Icon.BenchmarkingKpis: {
            return React.createElement(SvgBenchmarkingKpis, null);
        }
        case Icon.Book: {
            return React.createElement(SvgBook, null);
        }
        case Icon.Brain: {
            return React.createElement(SvgBrain, null);
        }
        case Icon.BrandFlower: {
            return React.createElement(SvgBrandFlower, null);
        }
        case Icon.Brochures: {
            return React.createElement(SvgBrochures, null);
        }
        case Icon.Bulb: {
            return React.createElement(SvgBulb, null);
        }
        case Icon.Bullet: {
            return React.createElement(SvgBullet, null);
        }
        case Icon.BulletFill: {
            return React.createElement(SvgBulletFill, null);
        }
        case Icon.BySector: {
            return React.createElement(SvgBySector, null);
        }
        case Icon.ByUseCase: {
            return React.createElement(SvgByUseCase, null);
        }
        case Icon.CandidateAssessment: {
            return React.createElement(SvgCandidateAssessment, null);
        }
        case Icon.CandidateAttractionProactiveRecruitment: {
            return React.createElement(SvgCandidateAttractionProactiveRecruitment, null);
        }
        case Icon.CandidateEngagementAgencyFeedbackChat: {
            return React.createElement(SvgCandidateEngagementAgencyFeedbackChat, null);
        }
        case Icon.CandidateExperience: {
            return React.createElement(SvgCandidateExperience, null);
        }
        case Icon.CandidatePortal: {
            return React.createElement(SvgCandidatePortal, null);
        }
        case Icon.CandidateSelfService: {
            return React.createElement(SvgCandidateSelfService, null);
        }
        case Icon.Candidates: {
            return React.createElement(SvgCandidates, null);
        }
        case Icon.CareersWebsiteDesign: {
            return React.createElement(SvgCareersWebsiteDesign, null);
        }
        case Icon.CareersWebsiteInterface: {
            return React.createElement(SvgCareersWebsiteInterface, null);
        }
        case Icon.Careers: {
            return React.createElement(SvgCareers, null);
        }
        case Icon.CaseStudy: {
            return React.createElement(SvgCaseStudy, null);
        }
        case Icon.ChainBreak: {
            return React.createElement(SvgChainBreak, null);
        }
        case Icon.CharitiesNfpWellnessHealthSocialCare: {
            return React.createElement(SvgCharitiesNfpWellnessHealthSocialCare, null);
        }
        case Icon.ChevronRight: {
            return React.createElement(SvgChevronRight, null);
        }
        case Icon.Chevron: {
            return React.createElement(SvgChevron, null);
        }
        case Icon.CircleClose: {
            return React.createElement(SvgCircleClose, null);
        }
        case Icon.ClipboardTick: {
            return React.createElement(SvgClipboardTick, null);
        }
        case Icon.ClockTurn: {
            return React.createElement(SvgClockTurn, null);
        }
        case Icon.Clock: {
            return React.createElement(SvgClock, null);
        }
        case Icon.Collaboration: {
            return React.createElement(SvgCollaboration, null);
        }
        case Icon.CommunicationFeedback: {
            return React.createElement(SvgCommunicationFeedback, null);
        }
        case Icon.CompanyBrandLogoeye: {
            return React.createElement(SvgCompanyBrandLogoeye, null);
        }
        case Icon.Compliance: {
            return React.createElement(SvgCompliance, null);
        }
        case Icon.Configurability: {
            return React.createElement(SvgConfigurability, null);
        }
        case Icon.ConstructionInfrastructure: {
            return React.createElement(SvgConstructionInfrastructure, null);
        }
        case Icon.ContractsAndEsignatures: {
            return React.createElement(SvgContractsAndEsignatures, null);
        }
        case Icon.CrossClose: {
            return React.createElement(SvgCrossClose, null);
        }
        case Icon.CustomerSuccess: {
            return React.createElement(SvgCustomerSuccess, null);
        }
        case Icon.Customer: {
            return React.createElement(SvgCustomer, null);
        }
        case Icon.CustomisableOptions: {
            return React.createElement(SvgCustomisableOptions, null);
        }
        case Icon.DashboardsAndAnalytics: {
            return React.createElement(SvgDashboardsAndAnalytics, null);
        }
        case Icon.DataAccess: {
            return React.createElement(SvgDataAccess, null);
        }
        case Icon.Datasheets: {
            return React.createElement(SvgDatasheets, null);
        }
        case Icon.DeveloperTools: {
            return React.createElement(SvgDeveloperTools, null);
        }
        case Icon.Developer: {
            return React.createElement(SvgDeveloper, null);
        }
        case Icon.Download: {
            return React.createElement(SvgDownload, null);
        }
        case Icon.EbooksAndReports: {
            return React.createElement(SvgEbooksAndReports, null);
        }
        case Icon.Edi: {
            return React.createElement(SvgEdi, null);
        }
        case Icon.Edit: {
            return React.createElement(SvgEdit, null);
        }
        case Icon.Education: {
            return React.createElement(SvgEducation, null);
        }
        case Icon.Efficiency: {
            return React.createElement(SvgEfficiency, null);
        }
        case Icon.Email: {
            return React.createElement(SvgEmail, null);
        }
        case Icon.EmployeePortal: {
            return React.createElement(SvgEmployeePortal, null);
        }
        case Icon.EmployeeReferrals: {
            return React.createElement(SvgEmployeeReferrals, null);
        }
        case Icon.Employees: {
            return React.createElement(SvgEmployees, null);
        }
        case Icon.EmployerBrand: {
            return React.createElement(SvgEmployerBrand, null);
        }
        case Icon.EngineeringAndManufacturing: {
            return React.createElement(SvgEngineeringAndManufacturing, null);
        }
        case Icon.FacilitiesManagement: {
            return React.createElement(SvgFacilitiesManagement, null);
        }
        case Icon.Filter: {
            return React.createElement(SvgFilter, null);
        }
        case Icon.FinancialServices: {
            return React.createElement(SvgFinancialServices, null);
        }
        case Icon.Floorplan: {
            return React.createElement(SvgFloorplan, null);
        }
        case Icon.FoodAndDrink: {
            return React.createElement(SvgFoodAndDrink, null);
        }
        case Icon.Gdpr: {
            return React.createElement(SvgGdpr, null);
        }
        case Icon.Globe: {
            return React.createElement(SvgGlobe, null);
        }
        case Icon.Growth: {
            return React.createElement(SvgGrowth, null);
        }
        case Icon.HiringManagerPortal: {
            return React.createElement(SvgHiringManagerPortal, null);
        }
        case Icon.HiringManagers: {
            return React.createElement(SvgHiringManagers, null);
        }
        case Icon.Hospitality: {
            return React.createElement(SvgHospitality, null);
        }
        case Icon.HowWeWork: {
            return React.createElement(SvgHowWeWork, null);
        }
        case Icon.Hr: {
            return React.createElement(SvgHr, null);
        }
        case Icon.Implementation: {
            return React.createElement(SvgImplementation, null);
        }
        case Icon.IndeedIntegration: {
            return React.createElement(SvgIndeedIntegration, null);
        }
        case Icon.InnovativeTechnology: {
            return React.createElement(SvgInnovativeTechnology, null);
        }
        case Icon.Integrations: {
            return React.createElement(SvgIntegrations, null);
        }
        case Icon.InterviewSchedulingCalendarsTimeAndAttendance: {
            return React.createElement(SvgInterviewSchedulingCalendarsTimeAndAttendance, null);
        }
        case Icon.Interviews: {
            return React.createElement(SvgInterviews, null);
        }
        case Icon.It: {
            return React.createElement(SvgIt, null);
        }
        case Icon.JobAdvertisingNews: {
            return React.createElement(SvgJobAdvertisingNews, null);
        }
        case Icon.JobLibrary: {
            return React.createElement(SvgJobLibrary, null);
        }
        case Icon.JobOffersAgencyPartnersAlliancePartnersChannelPartners: {
            return React.createElement(SvgJobOffersAgencyPartnersAlliancePartnersChannelPartners, null);
        }
        case Icon.JobRequisitionsBackgroundChecks: {
            return React.createElement(SvgJobRequisitionsBackgroundChecks, null);
        }
        case Icon.JobSearch: {
            return React.createElement(SvgJobSearch, null);
        }
        case Icon.KnowledgeBase: {
            return React.createElement(SvgKnowledgeBase, null);
        }
        case Icon.Legal: {
            return React.createElement(SvgLegal, null);
        }
        case Icon.Lightning: {
            return React.createElement(SvgLightning, null);
        }
        case Icon.Location: {
            return React.createElement(SvgLocation, null);
        }
        case Icon.Lock: {
            return React.createElement(SvgLock, null);
        }
        case Icon.Marketplace: {
            return React.createElement(SvgMarketplace, null);
        }
        case Icon.MeasureSatisfaction: {
            return React.createElement(SvgMeasureSatisfaction, null);
        }
        case Icon.Measure: {
            return React.createElement(SvgMeasure, null);
        }
        case Icon.MediaAndCreative: {
            return React.createElement(SvgMediaAndCreative, null);
        }
        case Icon.Menu: {
            return React.createElement(SvgMenu, null);
        }
        case Icon.MessageConfirm: {
            return React.createElement(SvgMessageConfirm, null);
        }
        case Icon.Metrics: {
            return React.createElement(SvgMetrics, null);
        }
        case Icon.Migration: {
            return React.createElement(SvgMigration, null);
        }
        case Icon.Minus: {
            return React.createElement(SvgMinus, null);
        }
        case Icon.MobileFriendly: {
            return React.createElement(SvgMobileFriendly, null);
        }
        case Icon.Money: {
            return React.createElement(SvgMoney, null);
        }
        case Icon.Multiposting: {
            return React.createElement(SvgMultiposting, null);
        }
        case Icon.NoData: {
            return React.createElement(SvgNoData, null);
        }
        case Icon.NonCompliance: {
            return React.createElement(SvgNonCompliance, null);
        }
        case Icon.Notifications: {
            return React.createElement(SvgNotifications, null);
        }
        case Icon.Onboarding: {
            return React.createElement(SvgOnboarding, null);
        }
        case Icon.OurServices: {
            return React.createElement(SvgOurServices, null);
        }
        case Icon.Partners: {
            return React.createElement(SvgPartners, null);
        }
        case Icon.Pencil: {
            return React.createElement(SvgPencil, null);
        }
        case Icon.Phone: {
            return React.createElement(SvgPhone, null);
        }
        case Icon.Pipelines: {
            return React.createElement(SvgPipelines, null);
        }
        case Icon.Play: {
            return React.createElement(SvgPlay, null);
        }
        case Icon.ProfessionalServicesAndConsultancies: {
            return React.createElement(SvgProfessionalServicesAndConsultancies, null);
        }
        case Icon.Profile: {
            return React.createElement(SvgProfile, null);
        }
        case Icon.PublicSector: {
            return React.createElement(SvgPublicSector, null);
        }
        case Icon.QuoteTestimonials: {
            return React.createElement(SvgQuoteTestimonials, null);
        }
        case Icon.RecruitmentMarketingTargettingOurimpact: {
            return React.createElement(SvgRecruitmentMarketingTargettingOurimpact, null);
        }
        case Icon.RecruitmentWorkflow: {
            return React.createElement(SvgRecruitmentWorkflow, null);
        }
        case Icon.ReferenceCollection: {
            return React.createElement(SvgReferenceCollection, null);
        }
        case Icon.ReferralProgrammeManagement: {
            return React.createElement(SvgReferralProgrammeManagement, null);
        }
        case Icon.Registration: {
            return React.createElement(SvgRegistration, null);
        }
        case Icon.RequestToRecruit: {
            return React.createElement(SvgRequestToRecruit, null);
        }
        case Icon.ResearchAndInstitutes: {
            return React.createElement(SvgResearchAndInstitutes, null);
        }
        case Icon.ResellCosell: {
            return React.createElement(SvgResellCosell, null);
        }
        case Icon.Resources: {
            return React.createElement(SvgResources, null);
        }
        case Icon.Retail: {
            return React.createElement(SvgRetail, null);
        }
        case Icon.RewardStore: {
            return React.createElement(SvgRewardStore, null);
        }
        case Icon.Rpo: {
            return React.createElement(SvgRpo, null);
        }
        case Icon.RtwChecks: {
            return React.createElement(SvgRtwChecks, null);
        }
        case Icon.SadFace: {
            return React.createElement(SvgSadFace, null);
        }
        case Icon.ScienceAndPharma: {
            return React.createElement(SvgScienceAndPharma, null);
        }
        case Icon.SearchTalentPool: {
            return React.createElement(SvgSearchTalentPool, null);
        }
        case Icon.Search: {
            return React.createElement(SvgSearch, null);
        }
        case Icon.Security: {
            return React.createElement(SvgSecurity, null);
        }
        case Icon.Sent: {
            return React.createElement(SvgSent, null);
        }
        case Icon.SettingsVisualisationsRecruitmentCrm: {
            return React.createElement(SvgSettingsVisualisationsRecruitmentCrm, null);
        }
        case Icon.SingleSignOn: {
            return React.createElement(SvgSingleSignOn, null);
        }
        case Icon.SolveYourChallenges: {
            return React.createElement(SvgSolveYourChallenges, null);
        }
        case Icon.Stats: {
            return React.createElement(SvgStats, null);
        }
        case Icon.SubmitAServiceRequest: {
            return React.createElement(SvgSubmitAServiceRequest, null);
        }
        case Icon.SubmitAgencyCandidates: {
            return React.createElement(SvgSubmitAgencyCandidates, null);
        }
        case Icon.TalentMapping: {
            return React.createElement(SvgTalentMapping, null);
        }
        case Icon.TalentNurturing: {
            return React.createElement(SvgTalentNurturing, null);
        }
        case Icon.TalentPool: {
            return React.createElement(SvgTalentPool, null);
        }
        case Icon.TeamsManagementTeams: {
            return React.createElement(SvgTeamsManagementTeams, null);
        }
        case Icon.TechnologyTechPartners: {
            return React.createElement(SvgTechnologyTechPartners, null);
        }
        case Icon.ThumbsDown: {
            return React.createElement(SvgThumbsDown, null);
        }
        case Icon.ThumbsUp: {
            return React.createElement(SvgThumbsUp, null);
        }
        case Icon.TickInCircle: {
            return React.createElement(SvgTickInCircle, null);
        }
        case Icon.Tick: {
            return React.createElement(SvgTick, null);
        }
        case Icon.TimeToHireImprovement: {
            return React.createElement(SvgTimeToHireImprovement, null);
        }
        case Icon.Toolbox: {
            return React.createElement(SvgToolbox, null);
        }
        case Icon.Tracking: {
            return React.createElement(SvgTracking, null);
        }
        case Icon.Training: {
            return React.createElement(SvgTraining, null);
        }
        case Icon.TransportAndLogistics: {
            return React.createElement(SvgTransportAndLogistics, null);
        }
        case Icon.Upload: {
            return React.createElement(SvgUpload, null);
        }
        case Icon.UserFriendlyInterface: {
            return React.createElement(SvgUserFriendlyInterface, null);
        }
        case Icon.UserProvisioning: {
            return React.createElement(SvgUserProvisioning, null);
        }
        case Icon.User: {
            return React.createElement(SvgUser, null);
        }
        case Icon.UsersAndRoles: {
            return React.createElement(SvgUsersAndRoles, null);
        }
        case Icon.UtilitiesAndWasteManagement: {
            return React.createElement(SvgUtilitiesAndWasteManagement, null);
        }
        case Icon.Verified: {
            return React.createElement(SvgVerified, null);
        }
        case Icon.VideoInterviewing: {
            return React.createElement(SvgVideoInterviewing, null);
        }
        case Icon.Video: {
            return React.createElement(SvgVideo, null);
        }
        case Icon.Viewport: {
            return React.createElement(SvgViewport, null);
        }
        case Icon.Warning: {
            return React.createElement(SvgWarning, null);
        }
        case Icon.WhyEploy: {
            return React.createElement(SvgWhyEploy, null);
        }
        case Icon.Windows: {
            return React.createElement(SvgWindows, null);
        }
        case Icon.Workflow: {
            return React.createElement(SvgWorkflow, null);
        }
        case Icon.Wrench: {
            return React.createElement(SvgWrench, null);
        }
        // Custom
        case Icon.CopyLink: {
            return React.createElement(SvgCopyLink, null);
        }
        case Icon.Loader: {
            return React.createElement(PuffLoader, { color: "currentColor", size: 17 });
        }
        case Icon.Facebok: {
            return React.createElement(SvgFacebook, null);
        }
        case Icon.FounderResources: {
            return React.createElement(SvgFounderResources, null);
        }
        case Icon.G2: {
            return React.createElement(SvgG2, null);
        }
        case Icon.Instagram: {
            return React.createElement(SvgInstagram, null);
        }
        case Icon.LinkedIn: {
            return React.createElement(SvgLinkedIn, null);
        }
        case Icon.Pinterest: {
            return React.createElement(SvgPinterest, null);
        }
        case Icon.X: {
            return React.createElement(SvgX, null);
        }
        case Icon.YouTube: {
            return React.createElement(SvgYouTube, null);
        }
        case Icon.None:
        default: {
            return null;
        }
    }
}
